<template>
  <div>
    로그아웃
  </div>
</template>

<script>
export default {
  mounted() {
    if (!this.loggedInUser) {
      this.openLink('/')
    }
  }
}
</script>
